import { WebContentService } from 'aa-ct-web-content-service';
import { registerComponent as registerComponent$1 } from '@aileron/button';
import { registerComponent } from '@aileron/icon';
import { unsafeCSS, LitElement, css, html } from 'lit';
import { property, query, queryAll, customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import '@aileron/divider';
import { registerComponent as registerComponent$3 } from '@aileron/grid';
import { registerComponent as registerComponent$4 } from '@aileron/link';
import { registerComponent as registerComponent$5 } from '@aileron/nav-bar';
import '@aileron/popover';
import { registerComponent as registerComponent$6 } from '@aileron/tabs';
import { registerComponent as registerComponent$2 } from '@aileron/text-input';
import '@aileron-web/account-dropdown';
import '@aileron-web/language-selector';

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$2(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) for (var prop of __getOwnPropSymbols$1(b)) {
    if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const setHostListener = (type, options, Clazz, name) => {
  const hostListeners = Clazz._hostListeners;
  if (!hostListeners) {
    throw new Error("The method `@HostListener()` is defined on has to be of a class that has `HostListerMixin`.");
  }
  if (!hostListeners[name]) {
    hostListeners[name] = {};
  }
  hostListeners[name][type] = {
    options
  };
};
const HostListenerStandard = (type, options, descriptor) => {
  const {
    kind,
    key,
    placement
  } = descriptor;
  if (!(kind === "method" && placement === "prototype" || kind === "field" && placement === "own")) {
    throw new Error("`@HostListener()` must be defined on instance methods, but you may have defined it on static, field, etc.");
  }
  return __spreadProps(__spreadValues$1({}, descriptor), {
    finisher(Clazz) {
      setHostListener(type, options, Clazz, key);
    }
  });
};
const HostListener = (type, options) => (targetOrDescriptor, name) => typeof name !== "undefined" ? setHostListener(type, options, targetOrDescriptor.constructor, name) : HostListenerStandard(type, options, targetOrDescriptor);

function on(element, ...args) {
  element.addEventListener(...args);
  return {
    release() {
      element.removeEventListener(...args);
      return null;
    }
  };
}
const EVENT_NAME_FORMAT = /^((document|window|parentRoot|shadowRoot):)?([\w-]+)$/;
function HostListenerMixin(Base) {
  class HostListenerMixinImpl extends Base {
    constructor(...args) {
      super(...args);
      this._handles = /* @__PURE__ */new Set();
    }
    connectedCallback() {
      super.connectedCallback();
      const hostListeners = this.constructor._hostListeners;
      Object.keys(hostListeners).forEach(listenerName => {
        Object.keys(hostListeners[listenerName]).forEach(type => {
          var _a;
          const tokens = EVENT_NAME_FORMAT.exec(type);
          if (!tokens) {
            throw new Error(`Could not parse the event name: ${listenerName}`);
          }
          const [,, targetName, unprefixedType] = tokens;
          const target = {
            document: this.ownerDocument,
            window: this.ownerDocument.defaultView,
            parentRoot: this.getRootNode(),
            shadowRoot: this.shadowRoot
          }[targetName] || this;
          const {
            options
          } = hostListeners[listenerName][type];
          this._handles.add(on(target, (_a = this.constructor[unprefixedType]) != null ? _a : unprefixedType, this[listenerName], options));
        });
      });
    }
    disconnectedCallback() {
      this._handles.forEach(handle => {
        handle.release();
        this._handles.delete(handle);
      });
      super.disconnectedCallback();
    }
  }
  HostListenerMixinImpl._hostListeners = {};
  return HostListenerMixinImpl;
}

class GlobalDataController {
  static _isHomePage() {
    const homePage = /\/?home/i;
    const {
      href
    } = window.location;
    return homePage.test(href);
  }
  static getEnvironment() {
    const hostname = window.location.hostname;
    return /^.*\.stage\.aa\.com$/.test(hostname) ? "stage" : /^.*\.qa\.aa\.com$/.test(hostname) || hostname === "localhost" ? "qa" : "prod";
  }
}

class GlobalTranslations {}
GlobalTranslations.DATA = {
  "en_US": {
    "OneWorld": "oneworld link opens in a new window",
    "newWinText": ", Opens in a new window.",
    "newWinExtText": ", Opens another site in a new window that may not meet accessibility guidelines."
  },
  "es": {
    "OneWorld": "El enlace de oneworld abre en una nueva ventana",
    "newWinText": ", Abre en una nueva ventana.",
    "newWinExtText": ", Abre una nueva ventana de otro sitio web que podr\xEDa no cumplir con las normas de accesibilidad."
  },
  "fr": {
    "OneWorld": `Le lien oneworld s'ouvre dans une nouvelle fen\xEAtre`,
    "newWinText": ", Ouvre dans une nouvelle fen\xEAtre.",
    "newWinExtText": ", Ouvre un nouveau site dans une nouvelle fen\xEAtre pouvant ne pas respecter les directives d\u2019accessibilit\xE9."
  },
  "pt": {
    "OneWorld": "O link da oneworld abre em uma nova janela",
    "newWinText": ", Abre em uma nova janela.",
    "newWinExtText": ", Abre um outro site numa nova janela que pode n\xE3o cumprir as normas de acessibilidade."
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var axios$3 = {exports: {}};

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$9 = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$8 = utils$9;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$8.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$8.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$8.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$8.forEach(val, function parseValue(v) {
        if (utils$8.isDate(v)) {
          v = v.toISOString();
        } else if (utils$8.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$7 = utils$9;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$7.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$6 = utils$9;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$6.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$1 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError;
var hasRequiredCreateError;

function requireCreateError () {
	if (hasRequiredCreateError) return createError;
	hasRequiredCreateError = 1;

	var enhanceError = enhanceError$1;

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	return createError;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var createError = requireCreateError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$9;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;

function requireIsAbsoluteURL () {
	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
	hasRequiredIsAbsoluteURL = 1;

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	return isAbsoluteURL;
}

var combineURLs;
var hasRequiredCombineURLs;

function requireCombineURLs () {
	if (hasRequiredCombineURLs) return combineURLs;
	hasRequiredCombineURLs = 1;

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	return combineURLs;
}

var buildFullPath;
var hasRequiredBuildFullPath;

function requireBuildFullPath () {
	if (hasRequiredBuildFullPath) return buildFullPath;
	hasRequiredBuildFullPath = 1;

	var isAbsoluteURL = requireIsAbsoluteURL();
	var combineURLs = requireCombineURLs();

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	return buildFullPath;
}

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$9;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$9;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$9;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = requireBuildFullPath();
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var createError = requireCreateError();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;

	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(resolve, reject, response);

	      // Clean up request
	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }

	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var utils$5 = utils$9;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = requireXhr();
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = requireXhr();
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$5.isFormData(data) ||
      utils$5.isArrayBuffer(data) ||
      utils$5.isBuffer(data) ||
      utils$5.isStream(data) ||
      utils$5.isFile(data) ||
      utils$5.isBlob(data)
    ) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$5.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$5.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$3.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$4 = utils$9;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$3 = utils$9;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$9;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$2.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var name$1 = "axios";
var version$1 = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var require$$0 = {
	name: name$1,
	version: version$1,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var pkg = require$$0;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$9;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel_1;
var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return Cancel_1;
	hasRequiredCancel = 1;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;

	Cancel_1 = Cancel;
	return Cancel_1;
}

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var Cancel = requireCancel();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError;
	hasRequiredIsAxiosError = 1;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	return isAxiosError;
}

var utils = utils$9;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = requireCancel();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();

// Expose isAxiosError
axios$1.isAxiosError = requireIsAxiosError();

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

(function (module) {
	module.exports = axios$2.exports;
} (axios$3));

var axios = /*@__PURE__*/getDefaultExportFromCjs(axios$3.exports);

class AuthService {
  getAuthStatus(urlParamValue) {
    const accessLevelURL = "/loyalty/access-level";
    return axios.get(urlParamValue ? `${accessLevelURL}?locale=${urlParamValue}` : accessLevelURL).then(res => {
      return res.data;
    }).catch(err => {
      throw err;
    });
  }
  getMemberInformation() {
    return axios.get("/loyalty/api/member-information").then(resp => {
      return resp.data;
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }
}

var AuthStatus = /* @__PURE__ */(AuthStatus2 => {
  AuthStatus2["GUEST"] = "0";
  AuthStatus2["UNSECURED"] = "1";
  AuthStatus2["SECURED"] = "2";
  return AuthStatus2;
})(AuthStatus || {});

var newWinText = "Opens in a new window.";
var newWinTextExternal = "Opens another site in a new window that may not meet accessibility guidelines.";
var logo = {
	href: "/homePage.do",
	src: "https://www.aa.com/content/images/icons-logos/logos/logo-american-short-header.png",
	ImgAltText: "American Airlines logo"
};
var oneWorldLogo = {
	href: "/i18n/travel-info/partner-airlines/oneworld-airline-partners.jsp?from=comp_nav",
	src: "https://www.aa.com/content/images/icons-logos/logos/logo-oneworld.svg",
	ImgAltText: "oneworld logo",
	external: false,
	newWin: true
};
var meganavLinks = {
	commonLinks: [
		{
			linkText: "Flight status",
			href: "/travelInformation/flights/status?anchorEvent=false&from=comp_nav",
			external: false,
			newWin: false
		},
		{
			linkText: "Check in",
			href: "/reservation/flightCheckInViewReservationsAccess.do?anchorEvent=false&from=comp_nav",
			external: false,
			newWin: false
		},
		{
			linkText: "Your trips",
			href: "/reservation/viewReservationsAccess.do?anchorEvent=false&from=comp_nav",
			external: false,
			newWin: false
		},
		{
			linkText: "Your account",
			href: "/loyalty/profile/summary?anchorEvent=false&from=comp_nav",
			external: false,
			newWin: false
		},
		{
			linkText: "Join AAdvantage®",
			href: "/AAdvantage/quickEnroll.do?from=comp_nav&anchorEvent=false&referer=/apps/&anchorLocation=Navigation+Menu&url=%2FAAdvantage%2FquickEnroll.do&&reportedTitle=AAdvantage+Enroll+Now",
			external: false,
			newWin: false
		}
	],
	menu: [
		{
			heading: "Plan travel",
			sideNote: "<strong>Taking a trip?</strong> <br> We have your<br> travel plans covered.",
			columns: [
				{
					Links: [
						{
							linkText: "Flights",
							href: "/reservation/roundTripSearchAccess.do?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Hotels",
							href: "https://www.aadvantagehotels.com/?utm_source=aa.com&utm_medium=backlink&utm_campaign=partner-placement&utm_term=home-page&utm_content=plan-travel-navigation&label=aa-homepage-nav",
							external: true,
							newWin: true
						},
						{
							linkText: "Cars",
							href: "/car?src=AANAVCAR&from=comp_nav",
							external: false,
							newWin: true
						},
						{
							linkText: "Vacations",
							href: "https://www.aavacations.com/homePage?ADID=AACM-NAV-ALL-13-06",
							external: true,
							newWin: true
						},
						{
							linkText: "Cruises",
							href: "https://www.bookaacruises.com/?utm_medium=partner_site_hp_dd&utm_source=aa-aa.com&utm_campaign=plan_travel",
							external: true,
							newWin: true
						}
					]
				},
				{
					Links: [
						{
							linkText: "Book with miles",
							href: "/i18n/aadvantage-program/miles/redeem/redeem-miles.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Travel deals and offers",
							href: "/i18n/plan-travel/travel-deals-and-offers.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Flight schedules and notifications",
							href: "/travelInformation/flights/schedule?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Find the latest travel requirements",
							href: "https://apply.joinsherpa.com/map?affiliateId=americanairlines&from=headerNav",
							external: true,
							newWin: true
						}
					]
				}
			]
		},
		{
			heading: "Travel information",
			sideNote: "<strong>Taking a vacation?</strong><br>Allow us to simplify your travels.",
			columns: [
				{
					Links: [
						{
							linkText: "At the airport",
							href: "/i18n/travel-info/at-the-airport.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Travel experience",
							href: "/i18n/travel-info/experience/travel-experience.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Mobile and app",
							href: "/i18n/travel-info/travel-tools/mobile-and-app.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Planes",
							href: "/i18n/travel-info/experience/planes/planes.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Lounges",
							href: "/i18n/travel-info/clubs/lounges.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						}
					]
				},
				{
					Links: [
						{
							linkText: "Bags",
							href: "/i18n/travel-info/baggage/baggage.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "International travel",
							href: "/i18n/travel-info/international-travel/international-travel.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Special assistance",
							href: "/i18n/travel-info/special-assistance/special-assistance.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Airline partnerships",
							href: "/i18n/travel-info/partner-airlines/airline-partnerships.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						}
					]
				}
			]
		},
		{
			heading: "AAdvantage®",
			sideNote: "<strong>Traveling the world?</strong><br> Our loyalty program can get you there.",
			columns: [
				{
					Links: [
						{
							linkText: "AAdvantage® program",
							href: "/i18n/aadvantage-program/aadvantage-program.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "AAdvantage® status",
							href: "/i18n/aadvantage-program/aadvantage-status/aadvantage-status.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Earn miles",
							href: "/i18n/aadvantage-program/miles/earn/earn-miles.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Redeem miles",
							href: "/i18n/aadvantage-program/miles/redeem/redeem-miles.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Award travel",
							href: "/i18n/aadvantage-program/miles/redeem/award-travel/award-travel.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						}
					]
				},
				{
					Links: [
						{
							linkText: "AAdvantage Business™ program",
							href: "/i18n/aadvantage-program/aadvantage-business/overview.jsp?anchorEvent=false&from=comp_nav",
							external: false,
							newWin: false
						},
						{
							linkText: "Earn miles with our partners",
							href: "https://earnmoremiles.aa.com/BonusOffers",
							external: true,
							newWin: true
						},
						{
							linkText: "Buy, gift or transfer miles",
							href: "/aadvantage-program/buy-gift-transfer/en_US/home/buy?cint=DSP||20190919|BGT|ADV|TXL||NAV_BUY&from=comp_nav",
							external: true,
							newWin: true
						},
						{
							linkText: "AAdvantage® credit cards",
							href: "/i18n/aadvantage-program/miles/partners/credit-card/aadvantage-credit-cards.jsp?cint=DSP||20150923|ADV|PUB|LNK||EARN_MILES_HEADER_NAV&from=comp_nav",
							external: false,
							newWin: false
						}
					]
				}
			]
		}
	]
};
var headerData = {
	newWinText: newWinText,
	newWinTextExternal: newWinTextExternal,
	logo: logo,
	oneWorldLogo: oneWorldLogo,
	meganavLinks: meganavLinks
};

var data = /*#__PURE__*/Object.freeze({
  __proto__: null,
  newWinText: newWinText,
  newWinTextExternal: newWinTextExternal,
  logo: logo,
  oneWorldLogo: oneWorldLogo,
  meganavLinks: meganavLinks,
  'default': headerData
});

var awardMilesFormatted = "123,000";
var tierLevelFormatted = "AAdvantage Platinum Executive®";
var loyaltyPointsFormatted = "0";
var tierLevelExpiration = {
};
var awardMilesExpiration = {
	urgency: "low",
	expirationDate: "Miles expire on Dec 16, 2024"
};
var cobrandMembership = "";
var tierLevel = "Platinum Executive";
var millionMilerMiles = "67,890";
var awardMiles = {
	label: "Award miles:",
	value: "123,000"
};
var firstLastName = "John Smith";
var enrollmentDate = "AAdvantage® member since: Oct 27, 2010";
var name = "John Brown Smith";
var initials = "JS";
var aadvantageNumber = "05CJD12";
var memberInfoMockData = {
	awardMilesFormatted: awardMilesFormatted,
	tierLevelFormatted: tierLevelFormatted,
	loyaltyPointsFormatted: loyaltyPointsFormatted,
	tierLevelExpiration: tierLevelExpiration,
	awardMilesExpiration: awardMilesExpiration,
	cobrandMembership: cobrandMembership,
	tierLevel: tierLevel,
	millionMilerMiles: millionMilerMiles,
	awardMiles: awardMiles,
	firstLastName: firstLastName,
	enrollmentDate: enrollmentDate,
	name: name,
	initials: initials,
	aadvantageNumber: aadvantageNumber
};

var memberData = /*#__PURE__*/Object.freeze({
  __proto__: null,
  awardMilesFormatted: awardMilesFormatted,
  tierLevelFormatted: tierLevelFormatted,
  loyaltyPointsFormatted: loyaltyPointsFormatted,
  tierLevelExpiration: tierLevelExpiration,
  awardMilesExpiration: awardMilesExpiration,
  cobrandMembership: cobrandMembership,
  tierLevel: tierLevel,
  millionMilerMiles: millionMilerMiles,
  awardMiles: awardMiles,
  firstLastName: firstLastName,
  enrollmentDate: enrollmentDate,
  name: name,
  initials: initials,
  aadvantageNumber: aadvantageNumber,
  'default': memberInfoMockData
});

class Rollup {}
Rollup.DATA = {
  "rollup": {
    "en_AG": ["en_CB"],
    "en_AI": ["en_CB"],
    "en_AW": ["en_CB"],
    "en_BB": ["en_CB"],
    "en_BM": ["en_CB"],
    "en_BQ": ["en_CB"],
    "en_BS": ["en_CB"],
    "en_CW": ["en_CB"],
    "en_DM": ["en_CB"],
    "en_GD": ["en_CB"],
    "en_HT": ["en_CB"],
    "en_JM": ["en_CB"],
    "en_KN": ["en_CB"],
    "en_KY": ["en_CB"],
    "en_LC": ["en_CB"],
    "en_SX": ["en_CB"],
    "en_TC": ["en_CB"],
    "en_TT": ["en_CB"],
    "en_VC": ["en_CB"],
    "en_VG": ["en_CB"],
    "es_US": ["es"],
    "es_AR": ["es"],
    "es_BO": ["es"],
    "es_CL": ["es"],
    "es_CO": ["es"],
    "es_CR": ["es"],
    "es_DO": ["es"],
    "es_EC": ["es"],
    "es_GT": ["es"],
    "es_HN": ["es"],
    "es_MX": ["es"],
    "es_NI": ["es"],
    "es_PA": ["es"],
    "es_PE": ["es"],
    "es_PR": ["es"],
    "es_PY": ["es"],
    "es_SV": ["es"],
    "es_UY": ["es"],
    "es_VE": ["es"],
    "en_CA": ["en_US"],
    "en_BZ": ["en_US"],
    "en_PR": ["en_US"],
    "pt_BR": ["pt"],
    "pt_PT": ["pt", "en_EU"],
    "en_BE": ["en_EU"],
    "en_CH": ["en_EU"],
    "en_CZ": ["en_EU"],
    "en_DE": ["en_EU"],
    "en_DK": ["en_EU"],
    "en_ES": ["en_EU"],
    "en_FI": ["en_EU"],
    "en_FR": ["en_EU"],
    "en_GB": ["en_EU"],
    "en_GR": ["en_EU"],
    "en_HR": ["en_EU"],
    "en_HU": ["en_EU"],
    "en_IE": ["en_EU"],
    "en_IL": ["en_EU"],
    "en_IS": ["en_EU"],
    "en_IT": ["en_EU"],
    "en_MA": ["en_EU"],
    "en_ME": ["en_EU"],
    "en_NL": ["en_EU"],
    "en_NO": ["en_EU"],
    "en_PL": ["en_EU"],
    "en_PT": ["en_EU"],
    "en_QA": ["en_EU"],
    "en_RU": ["en_EU"],
    "en_SE": ["en_EU"],
    "fr_BE": ["fr"],
    "fr_CA": ["fr"],
    "fr_CH": ["fr"],
    "fr_FR": ["fr"],
    "fr_MA": ["fr"],
    "it_IT": ["it", "en_EU"],
    "nl_NL": ["nl", "en_EU"],
    "nl_BE": ["nl", "en_EU"],
    "es_ES": ["es", "en_EU"],
    "de_DE": ["de", "en_EU"],
    "de_CH": ["de", "en_EU"],
    "fi_FI": ["fi", "en_EU"],
    "ru_RU": ["ru", "en_EU"],
    "en_AU": ["en_AP"],
    "en_CN": ["en_AP"],
    "en_HK": ["en_AP"],
    "en_IN": ["en_AP"],
    "en_JP": ["en_AP"],
    "en_KR": ["en_AP"],
    "en_NZ": ["en_AP"],
    "en_SG": ["en_AP"],
    "ja_JP": ["ja", "en_AP"],
    "ko_KR": ["ko", "en_AP"],
    "zh_CN": ["zh", "en_AP"],
    "zh_HK": ["zh", "en_AP"]
  }
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
const _TranslationDataController = class {
  static getLocaleTranslations(locale, componentTranslations) {
    const updateLocale = this.transformLocaleFormat(locale);
    const rollupLocales = ["en_US", ...(Rollup.DATA.rollup[updateLocale] || []).reverse(), updateLocale];
    for (const code of rollupLocales) {
      _TranslationDataController.translations = __spreadValues(__spreadValues({}, _TranslationDataController.translations), componentTranslations.DATA[code]);
    }
  }
  static transformLocaleFormat(s) {
    return s.replace("-", "_");
  }
  static _checkCookie() {
    let cookie = "en_US";
    const cookiesList = this.getCookies("sessionLocale");
    if (cookiesList.length > 0) {
      cookie = this.transformLocaleFormat(cookiesList[0]);
    }
    return cookie;
  }
  static updateCookie(urlParamValue) {
    const cookiesList = this.getCookies("sessionLocale");
    if (cookiesList.length > 1) {
      document.cookie = `sessionLocale=;max-age=0`;
    }
    document.cookie = `sessionLocale=${urlParamValue}; path=/`;
  }
  static updateCookiePref(urlParamValue) {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    const baseUrl = document.location.hostname;
    const subdomain = baseUrl.includes(".qa.") ? baseUrl.slice(0, baseUrl.indexOf(".qa") + 3) : "www";
    document.cookie = `locale=${urlParamValue}; domain=.${subdomain}.aa.com; path=/; expires=${expirationDate.toUTCString()};`;
  }
  static retrieveLocale() {
    let locale = "en_US";
    const prefValue = this.getURLParam("pref");
    const urlParamValue = this.getURLParam("locale");
    if (urlParamValue) {
      const isCorrectFormat = this.checkLocaleFormat(urlParamValue);
      if (isCorrectFormat) {
        if (typeof urlParamValue === "string") {
          locale = this.transformLocaleFormat(urlParamValue);
        }
        if (!this.isCookieSetFromURL) {
          if (prefValue) {
            this.updateCookiePref(locale);
          }
          this.updateCookie(locale);
          this.isCookieSetFromURL = true;
        }
      }
    } else {
      const cookieValue = this._checkCookie();
      if (cookieValue !== null && cookieValue !== void 0) {
        locale = this.transformLocaleFormat(cookieValue);
      }
    }
    return locale;
  }
  static getURLParam(param) {
    const currentPageURL = new URLSearchParams(window.location.search);
    const urlParamValue = currentPageURL.get(param);
    if (param === "locale") {
      return urlParamValue !== null && urlParamValue !== void 0 ? urlParamValue : "";
    } else {
      return urlParamValue === "true";
    }
  }
  static async getTranslationData(componentName, protocol) {
    const locale = this.retrieveLocale();
    const isAmadeusOrLocal = ["localhost", "amadeus"].some(host => document.location.hostname.includes(host));
    const baseUrl = isAmadeusOrLocal ? document.location.hostname.includes("bookaa.amadeus") ? "www.aa.com" : "iqa2.qa.aa.com" : document.location.hostname;
    if (locale in Rollup.DATA.rollup) {
      const locales = [locale, ...Rollup.DATA.rollup[locale], "en_US"];
      for (const loc of locales) {
        try {
          const response = await axios.get(`${protocol}//${baseUrl}/pubcontent/${loc}/fragments/navigation/${componentName}/${componentName}-${loc}.json`);
          return response;
        } catch (error) {
          continue;
        }
      }
    } else {
      try {
        const response = await axios.get(`${protocol}//${baseUrl}/pubcontent/${locale}/fragments/navigation/${componentName}/${componentName}-${locale}.json`);
        return response;
      } catch (error) {
        return error;
      }
    }
  }
  static getLocaleRollup(localeCode) {
    return Rollup.DATA.rollup[localeCode];
  }
  static checkLocaleFormat(localeCode) {
    const pattern = new RegExp("^[a-z]{2}_[A-Z]{2}$");
    return pattern.test(localeCode);
  }
  static getCookies(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    const cookieList = [];
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.startsWith(" ")) {
        c = c.substring(1);
      }
      if (c.startsWith(name)) {
        cookieList.push(c.substring(name.length, c.length));
      }
    }
    return cookieList;
  }
};
let TranslationDataController = _TranslationDataController;
TranslationDataController.isCookieSetFromURL = false;
TranslationDataController.translations = {};

class HeaderDataController {
  constructor(host) {
    this.webContentService = new WebContentService(GlobalDataController.getEnvironment());
    this.authService = new AuthService();
    this.authStatus = AuthStatus.GUEST;
    this.cobrandMembership = "";
    this.isDataFetched = false;
    (this.host = host).addController(this);
  }
  hostConnected() {
    this.fetchData();
    this.getGoDarkData();
    this.getAccountDetails().then(() => {
      this.host.requestUpdate();
    });
  }
  async fetchData() {
    const baseUrl = document.location.hostname;
    const protocol = document.location.protocol;
    if (baseUrl.includes("localhost") || baseUrl.includes("ideal-succotash")) {
      this.processData(data);
    } else {
      try {
        const response = await TranslationDataController.getTranslationData("header", protocol);
        this.processData(response.data);
        this.host.requestUpdate();
      } catch (error) {
        console.error("Error fetching translation data:", error);
      }
    }
  }
  getGoDarkData() {
    try {
      this.webContentService.fetchData(TranslationDataController.retrieveLocale(), "fragments/home-page/emergency-response/go-dark.json", "go-dark", "JSON").then(response => {
        this.goDarkData = response;
        this.host.requestUpdate();
      }).catch(error => {
        console.error("Error fetching goDarkData:", error);
      });
    } catch (error) {
      console.error("Unexpected error in getGoDarkData:", error);
    }
  }
  processData(jsonData) {
    this.menuData = JSON.parse(JSON.stringify(jsonData));
  }
  async getAccountDetails() {
    await this.getAuthStatus().then(() => {
      if (this.authStatus === AuthStatus.SECURED) {
        this.getMemberInformation().then(() => {
          this.getCoBrandMembership();
        });
      }
      this.isDataFetched = true;
    });
  }
  async getMemberInformation() {
    await this.authService.getMemberInformation().then(resp => {
      this.accountDetails = resp;
      this.host.requestUpdate();
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }
  async getCoBrandMembership() {
    await axios.get("/loyalty/api/membership").then(resp => {
      if (this.accountDetails) {
        this.accountDetails.cobrandMembership = resp.data.value;
      }
      this.host.requestUpdate();
    }).catch(err => {
      console.log("Loyalty api error", err);
    });
  }
  async getAuthStatus() {
    const urlParamValue = TranslationDataController.getURLParam();
    await this.authService.getAuthStatus(urlParamValue).then(resp => {
      this.authStatus = resp.status;
    }).catch(err => {
      const baseUrl = document.location.hostname;
      if (baseUrl.includes("aa.com") || baseUrl.includes("american")) {
        this.authStatus = AuthStatus.GUEST;
      } else {
        this.accountDetails = JSON.parse(JSON.stringify(memberData));
      }
      console.log("authStatus error, ", err);
    });
  }
}

var esm = {};

var AileronLogger$1 = {};

var GenerateBrowserData = {};

Object.defineProperty(GenerateBrowserData, "__esModule", { value: true });
GenerateBrowserData.generateBrowserData = void 0;
function determineOS() {
    let OSName = "Unknown";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
        OSName = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
        OSName = "Windows 8.1";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
        OSName = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
        OSName = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
        OSName = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
        OSName = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
        OSName = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") != -1)
        OSName = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") != -1)
        OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1)
        OSName = "Linux";
    return OSName;
}
function determineBrowser() {
    if (navigator.userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    }
    if (navigator.userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    }
    if (navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("rv:") > -1) {
        return "Internet Explorer";
    }
    if (navigator.userAgent.indexOf("Safari") > -1) {
        if (navigator.userAgent.indexOf("Chrome") > -1) {
            return "Chrome";
        }
        else
            return "Safari";
    }
    return "N/A";
}
function generateBrowserData() {
    const browserData = {
        href: document.location.href,
        protocol: document.location.protocol,
        os: determineOS(),
        browser: determineBrowser(),
        host: document.location.host,
    };
    return browserData;
}
GenerateBrowserData.generateBrowserData = generateBrowserData;

var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(AileronLogger$1, "__esModule", { value: true });
AileronLogger$1.AileronLogger = void 0;
const GenerateBrowserData_1 = GenerateBrowserData;
class AileronLogger {
    constructor(appName, environment = 'prod') {
        this.appName = appName;
        this.browserData = (0, GenerateBrowserData_1.generateBrowserData)();
        this.environment = environment;
    }
    log(message, level = "info", additional) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const logData = {
                "message": message,
                "level": level,
                "default": this.browserData,
                "additional": additional
            };
            let logUrl;
            try {
                logUrl = 'https://' + ((_a = this.browserData) === null || _a === void 0 ? void 0 : _a.host) + '/aileron/api/log';
            }
            catch (e) {
                logUrl = 'https://www.aa.com/aileron/api/log';
            }
            let response;
            try {
                response = yield fetch(logUrl, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "app": this.appName,
                        "env": this.environment
                    },
                    body: JSON.stringify(logData)
                });
            }
            catch (e) {
                response = e.message;
            }
            return response;
        });
    }
}
AileronLogger$1.AileronLogger = AileronLogger;

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AileronLogger = void 0;
	const AileronLogger_1 = AileronLogger$1;
	Object.defineProperty(exports, "AileronLogger", { enumerable: true, get: function () { return AileronLogger_1.AileronLogger; } });
} (esm));

class LogData {}
function Log(proto, _key) {
  const appName = "AACom-aileron-web";
  const urlToFetch = `${document.location.protocol}//${document.location.hostname}/pubcontent/en_US/fragments/aileron-web/aileron-logger-config.json`;
  let logLevel;
  let stack;
  let name;
  let message;
  let env = "prod";
  let config;
  let unhandledError = false;
  if (document.location.hostname.includes("stage.aa.com")) {
    env = "stage";
  } else if (document.location.hostname.includes("qa.aa.com") || document.location.hostname.includes("localhost")) {
    env = "qa";
  }
  const logger = new esm.AileronLogger(appName, env);
  const data = new LogData();
  const ctor = proto.constructor;
  window.onunhandledrejection = e => {
    unhandledError = true;
    const {
      reason
    } = e || {};
    const stack2 = reason.stack || "No stack available";
    const message2 = reason.message || "No message available";
    data.fullDetails = `Message: ${message2}
Stack: ${stack2}`;
  };
  ctor.addInitializer(async instance => {
    var _a, _b, _c, _d, _e;
    const sessionId = document.cookie.split("; QuantumMetricSessionID=");
    const userId = document.cookie.split("; QuantumMetricUserID=");
    try {
      config = await getLogSwitch(urlToFetch, env);
      logLevel = !unhandledError ? config == null ? void 0 : config.logLevel : 4 /* Error */;
      await instance.updateComplete;
      data.status = !unhandledError ? "success" : "Error";
      data.componentName = instance.tagName;
      data.componentVersion = instance["version"];
      data.loadTime = !unhandledError ? instance["loadTime"] : "";
      data.componentStatus = !unhandledError ? "200" : "500";
      data.location = document.location.hostname;
      data.level = !unhandledError ? "Info" : "Error";
      if (sessionId !== null && sessionId.length === 2) {
        data.QMSessionId = (_a = sessionId.pop()) == null ? void 0 : _a.split(";").shift();
      }
      if (userId !== null && userId.length === 2) {
        data.QMUserId = (_b = userId.pop()) == null ? void 0 : _b.split(";").shift();
      }
    } catch (e) {
      stack = e.stack;
      name = e.name;
      message = e.message;
      data.status = "Error";
      data.componentName = instance.tagName;
      data.componentVersion = instance["version"];
      data.componentStatus = "500";
      data.fullDetails = stack;
      data.location = document.location.hostname;
      data.level = "Error";
      if (sessionId !== null && sessionId.length === 2) {
        data.QMSessionId = (_c = sessionId.pop()) == null ? void 0 : _c.split(";").shift();
      }
      if (userId !== null && userId.length === 2) {
        data.QMUserId = (_d = userId.pop()) == null ? void 0 : _d.split(";").shift();
      }
      logLevel = 4 /* Error */;
    }
    const randomNum = Math.random();
    const loggingEnabled = config == null ? void 0 : config.loggingEnabled;
    const numerator = (_e = config == null ? void 0 : config.gradualRollout) == null ? void 0 : _e.numerator;
    const shouldLog = randomNum < numerator / 100;
    if (loggingEnabled) {
      if (logLevel === 0 /* Disabled */) {
        return;
      }
      if (shouldLog) {
        if (logLevel >= 4 /* Error */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${name} ${message}`, "Error", data);
        } else if (logLevel >= 3 /* Warn */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${name} ${message}`, data.level, data);
        } else if (logLevel >= 2 /* Info */) {
          await logger.log(`${instance.tagName} ${instance["version"]} ${data.location} ${data.status} ${data.loadTime}`, data.level, data);
        }
      }
    }
  });
  async function getLogSwitch(url, environment) {
    return fetch(url).then(resp => resp.json()).then(d => {
      return d.env.find(obj => obj.name.includes(environment));
    }).catch(() => {
      return null;
    });
  }
}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;const i=window,s$2=i.trustedTypes,e$1=s$2?s$2.createPolicy("lit-html",{createHTML:t=>t}):void 0,o$1="$lit$",n$2=`lit$${(Math.random()+"").slice(9)}$`,l$1="?"+n$2,h$1=`<${l$1}>`,r=document,u$1=()=>r.createComment(""),d=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c$1=Array.isArray,v=t=>c$1(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a$1="[ \t\n\f\r]",f$1=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_=/-->/g,m$1=/>/g,p$1=RegExp(`>|${a$1}(?:([^\\s"'>=/]+)(${a$1}*=${a$1}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g$1=/'/g,$$1=/"/g,y=/^(?:script|style|textarea|title)$/i,w$1=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),x=w$1(1),T$1=Symbol.for("lit-noChange"),A$1=Symbol.for("lit-nothing"),E=new WeakMap,C=r.createTreeWalker(r,129,null,!1);function P(t,i){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$1?e$1.createHTML(i):i}const V=(t,i)=>{const s=t.length-1,e=[];let l,r=2===i?"<svg>":"",u=f$1;for(let i=0;i<s;i++){const s=t[i];let d,c,v=-1,a=0;for(;a<s.length&&(u.lastIndex=a,c=u.exec(s),null!==c);)a=u.lastIndex,u===f$1?"!--"===c[1]?u=_:void 0!==c[1]?u=m$1:void 0!==c[2]?(y.test(c[2])&&(l=RegExp("</"+c[2],"g")),u=p$1):void 0!==c[3]&&(u=p$1):u===p$1?">"===c[0]?(u=null!=l?l:f$1,v=-1):void 0===c[1]?v=-2:(v=u.lastIndex-c[2].length,d=c[1],u=void 0===c[3]?p$1:'"'===c[3]?$$1:g$1):u===$$1||u===g$1?u=p$1:u===_||u===m$1?u=f$1:(u=p$1,l=void 0);const w=u===p$1&&t[i+1].startsWith("/>")?" ":"";r+=u===f$1?s+h$1:v>=0?(e.push(d),s.slice(0,v)+o$1+s.slice(v)+n$2+w):s+n$2+(-2===v?(e.push(void 0),i):w);}return [P(t,r+(t[s]||"<?>")+(2===i?"</svg>":"")),e]};class N$1{constructor({strings:t,_$litType$:i},e){let h;this.parts=[];let r=0,d=0;const c=t.length-1,v=this.parts,[a,f]=V(t,i);if(this.el=N$1.createElement(a,e),C.currentNode=this.el.content,2===i){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(h=C.nextNode())&&v.length<c;){if(1===h.nodeType){if(h.hasAttributes()){const t=[];for(const i of h.getAttributeNames())if(i.endsWith(o$1)||i.startsWith(n$2)){const s=f[d++];if(t.push(i),void 0!==s){const t=h.getAttribute(s.toLowerCase()+o$1).split(n$2),i=/([.?@])?(.*)/.exec(s);v.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?H:"?"===i[1]?L:"@"===i[1]?z$1:k$1});}else v.push({type:6,index:r});}for(const i of t)h.removeAttribute(i);}if(y.test(h.tagName)){const t=h.textContent.split(n$2),i=t.length-1;if(i>0){h.textContent=s$2?s$2.emptyScript:"";for(let s=0;s<i;s++)h.append(t[s],u$1()),C.nextNode(),v.push({type:2,index:++r});h.append(t[i],u$1());}}}else if(8===h.nodeType)if(h.data===l$1)v.push({type:2,index:r});else {let t=-1;for(;-1!==(t=h.data.indexOf(n$2,t+1));)v.push({type:7,index:r}),t+=n$2.length-1;}r++;}}static createElement(t,i){const s=r.createElement("template");return s.innerHTML=t,s}}function S(t,i,s=t,e){var o,n,l,h;if(i===T$1)return i;let r=void 0!==e?null===(o=s._$Co)||void 0===o?void 0:o[e]:s._$Cl;const u=d(i)?void 0:i._$litDirective$;return (null==r?void 0:r.constructor)!==u&&(null===(n=null==r?void 0:r._$AO)||void 0===n||n.call(r,!1),void 0===u?r=void 0:(r=new u(t),r._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Co)&&void 0!==l?l:h._$Co=[])[e]=r:s._$Cl=r),void 0!==r&&(i=S(t,r._$AS(t,i.values),r,e)),i}class M$1{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:r).importNode(s,!0);C.currentNode=o;let n=C.nextNode(),l=0,h=0,u=e[0];for(;void 0!==u;){if(l===u.index){let i;2===u.type?i=new R$1(n,n.nextSibling,this,t):1===u.type?i=new u.ctor(n,u.name,u.strings,this,t):6===u.type&&(i=new Z(n,this,t)),this._$AV.push(i),u=e[++h];}l!==(null==u?void 0:u.index)&&(n=C.nextNode(),l++);}return C.currentNode=r,o}v(t){let i=0;for(const s of this._$AV)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class R$1{constructor(t,i,s,e){var o;this.type=2,this._$AH=A$1,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cp=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===(null==t?void 0:t.nodeType)&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=S(this,t,i),d(t)?t===A$1||null==t||""===t?(this._$AH!==A$1&&this._$AR(),this._$AH=A$1):t!==this._$AH&&t!==T$1&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v(t)?this.T(t):this._(t);}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t));}_(t){this._$AH!==A$1&&d(this._$AH)?this._$AA.nextSibling.data=t:this.$(r.createTextNode(t)),this._$AH=t;}g(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=N$1.createElement(P(e.h,e.h[0]),this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.v(s);else {const t=new M$1(o,this),i=t.u(this.options);t.v(s),this.$(i),this._$AH=t;}}_$AC(t){let i=E.get(t.strings);return void 0===i&&E.set(t.strings,i=new N$1(t)),i}T(t){c$1(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new R$1(this.k(u$1()),this.k(u$1()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cp=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}}class k$1{constructor(t,i,s,e,o){this.type=1,this._$AH=A$1,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=A$1;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=S(this,t,i,0),n=!d(t)||t!==this._$AH&&t!==T$1,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=S(this,e[s+l],i,l),h===T$1&&(h=this._$AH[l]),n||(n=!d(h)||h!==this._$AH[l]),h===A$1?t=A$1:t!==A$1&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.j(t);}j(t){t===A$1?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}}class H extends k$1{constructor(){super(...arguments),this.type=3;}j(t){this.element[this.name]=t===A$1?void 0:t;}}const I$1=s$2?s$2.emptyScript:"";class L extends k$1{constructor(){super(...arguments),this.type=4;}j(t){t&&t!==A$1?this.element.setAttribute(this.name,I$1):this.element.removeAttribute(this.name);}}class z$1 extends k$1{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=S(this,t,i,0))&&void 0!==s?s:A$1)===T$1)return;const e=this._$AH,o=t===A$1&&e!==A$1||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==A$1&&(e===A$1||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}}class Z{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){S(this,t);}}const B$1=i.litHtmlPolyfillSupport;null==B$1||B$1(N$1,R$1),(null!==(t=i.litHtmlVersions)&&void 0!==t?t:i.litHtmlVersions=[]).push("2.8.0");

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const e=Symbol.for(""),l=t=>{if((null==t?void 0:t.r)===e)return null==t?void 0:t._$litStatic$},o=t=>({_$litStatic$:t,r:e}),s$1=new Map,a=t=>(r,...e)=>{const o=e.length;let i,a;const n=[],u=[];let c,$=0,f=!1;for(;$<o;){for(c=r[$];$<o&&void 0!==(a=e[$],i=l(a));)c+=i+r[++$],f=!0;$!==o&&u.push(a),n.push(c),$++;}if($===o&&n.push(r[o]),f){const t=n.join("$$lit$$");void 0===(r=s$1.get(t))&&(n.raw=n,s$1.set(t,r=n)),e=u;}return t(r,...e)},n$1=a(x);

const z = (a) => {
  class t extends a {
    constructor(...o) {
      super(...o), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (d) => d.href === this.fontLink
      ) === -1) {
        const d = document.createElement("link");
        d.href = this.fontLink, d.rel = "stylesheet", document.head.appendChild(d);
      }
    }
  }
  return t;
}, A = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.static{position:static}.-mt-px{margin-top:-1px}.mt-5{margin-top:1.25rem}.box-border{box-sizing:border-box}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-12{height:3rem}.h-9{height:2.25rem}.w-12{width:3rem}.w-9{width:2.25rem}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.items-center{align-items:center}.justify-center{justify-content:center}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-090{border-color:#b4c1cf}.border-transparent{border-color:transparent}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-transparent{background-color:transparent}.p-0{padding:0}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-neutral-000{color:#101419}.text-neutral-050{color:#405164}.text-neutral-090{color:#b4c1cf}.text-neutral-140{color:#fff}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:bg-neutral-090:disabled{background-color:#b4c1cf}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:focus\\:bg-blue-080:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:bg-blue-060:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0860c4}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}', N = unsafeCSS(A), u = "aileron-color-scheme", p = "aileron-color-scheme-change", F = (a) => {
  const e = class e extends a {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (r) => {
        r.detail ? this.setAttribute(u, r.detail) : this.removeAttribute(u);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        p,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const r = document.documentElement.getAttribute(
        u
      );
      r && this.setAttribute(u, r);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        p,
        this.handleSchemeSwitch
      );
    }
  };
  e.styles = [
    N,
    a.styles ?? []
  ];
  let t = e;
  return t;
}, g = F(z(LitElement));
function h(a, t) {
  function e(o) {
    if (!o || o === document || o === window)
      return null;
    o.assignedSlot && (o = o.assignedSlot);
    const r = o.closest(a);
    return r || e(o.getRootNode().host);
  }
  return e(t);
}
function f(a, t, e) {
  const o = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return a.dispatchEvent(o), o;
}
class D extends Event {
  constructor(t) {
    super("formdata"), this.formData = t;
  }
}
class T extends FormData {
  constructor(t) {
    super(t), this.form = t, t.dispatchEvent(new D(this));
  }
  append(t, e) {
    let o = this.form.elements[t];
    if (o || (o = document.createElement("input"), o.type = "hidden", o.name = t, this.form.appendChild(o)), this.has(t)) {
      const r = this.getAll(t), i = r.indexOf(o.value);
      i !== -1 && r.splice(i, 1), r.push(e), this.set(t, r);
    } else
      super.append(t, e);
    o.value = e;
  }
}
function M() {
  const a = document.createElement("form");
  let t = !1;
  return document.body.append(a), a.addEventListener("submit", (e) => {
    new FormData(e.target), e.preventDefault();
  }), a.addEventListener("formdata", () => t = !0), a.dispatchEvent(new Event("submit", { cancelable: !0 })), a.remove(), t;
}
function w() {
  !window.FormData || M() || (window.FormData = T, window.addEventListener("submit", (a) => {
    a.defaultPrevented || new FormData(a.target);
  }));
}
document.readyState === "complete" ? w() : window.addEventListener("DOMContentLoaded", () => w());
class $ {
  constructor(t, e) {
    (this.host = t).addController(this), this.options = {
      form: (o) => h("form", o),
      name: (o) => o.name,
      value: (o) => o.value,
      disabled: (o) => o.disabled,
      reportValidity: (o) => typeof o.reportValidity == "function" ? o.reportValidity() : !0,
      ...e
    }, this.options.form(this.host) && (this.options.form(this.host).noValidate = !0), this.handleFormData = this.handleFormData.bind(this), this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  hostConnected() {
    var t;
    this.form = (t = this.options) == null ? void 0 : t.form(this.host), this.form && (this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit));
  }
  hostDisconnected() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form = void 0);
  }
  handleFormData(t) {
    const e = this.options.disabled(this.host), o = this.options.name(this.host), r = this.options.value(this.host);
    !e && typeof o == "string" && typeof r < "u" && (Array.isArray(r) ? r.forEach((i) => {
      t.formData.append(o, i.toString());
    }) : t.formData.append(o, r.toString()));
  }
  handleFormSubmit(t) {
    const e = this.options.disabled(this.host);
    this.form && !e && (t.preventDefault(), t.stopImmediatePropagation());
  }
  submit(t) {
    if (this.form) {
      const e = document.createElement("button");
      e.type = "submit", e.style.position = "absolute", e.style.width = "0", e.style.height = "0", e.style.clipPath = "inset(50%)", e.style.overflow = "hidden", e.style.whiteSpace = "nowrap", t && ["formaction", "formmethod", "formnovalidate", "formtarget"].forEach((o) => {
        t.hasAttribute(o) && e.setAttribute(o, t.getAttribute(o));
      }), this.form.append(e), e.click(), e.remove();
    }
  }
}
class B {
  constructor(t, ...e) {
    this.slotNames = [], (this.host = t).addController(this), this.slotNames = e, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((t) => {
      var e;
      if (t.nodeType === t.TEXT_NODE && ((e = t.textContent) == null ? void 0 : e.trim()) !== "")
        return !0;
      if (t.nodeType === t.ELEMENT_NODE) {
        const o = t;
        if (o.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!o.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(t) {
    return this.host.querySelector(`:scope > [slot="${t}"]`) !== null;
  }
  test(t) {
    return t === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(t);
  }
  hostConnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var t;
    (t = this.host.shadowRoot) == null || t.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(t) {
    var o, r;
    const e = t.target;
    ((o = this.slotNames) != null && o.includes("[default]") && !e.name || e.name && ((r = this.slotNames) != null && r.includes(e.name))) && this.host.requestUpdate();
  }
}
const O = ":host{display:inline-flex}";
var I = Object.defineProperty, s = (a, t, e, o) => {
  for (var r = void 0, i = a.length - 1, b; i >= 0; i--)
    (b = a[i]) && (r = b(t, e, r) || r);
  return r && I(t, e, r), r;
};
const R = {
  SMALL: "16",
  LARGE: "24"
}, U = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GHOST: "ghost"
}, c = {
  SMALL: "sm",
  FIELD: "field",
  DEFAULT: ""
}, k = {
  BUTTON: "button",
  SUBMIT: "submit",
  RESET: "reset",
  MENU: "menu"
}, m = class m extends g {
  constructor(t) {
    super(), this.autofocus = !1, this.disabled = !1, this.labelText = "", this.kind = U.PRIMARY, this.size = c.DEFAULT, this.type = k.BUTTON, this.outlined = !1, this.filled = !1, this.name = "", this.iconSize = R.LARGE, this.hasSlotController = new B(this), this.formSubmitController = new $(this, {
      form: (e) => {
        if (e.hasAttribute("form")) {
          const o = e.getRootNode(), r = e.getAttribute("form");
          if (r)
            return o.getElementById(r);
        }
        return e.closest("form");
      }
    }), this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-button-icon"), registerComponent(
      this.customElementString ? this.customElementString + "-button-icon" : "adc-button-icon"
    );
  }
  click() {
    this.buttonNode.click();
  }
  focus(t) {
    this.buttonNode.focus(t);
  }
  blur() {
    this.buttonNode.blur();
  }
  handleBlur() {
    f(this, "adc-blur");
  }
  handleFocus() {
    f(this, "adc-focus");
  }
  handleClick() {
    this.type === k.SUBMIT && this.formSubmitController.submit(this), f(this, "adc-click");
  }
  updated(t) {
    super.updated(t), t.has("disabled") && (this.disabled ? this.buttonNode.setAttribute("disabled", "disabled") : this.buttonNode.removeAttribute("disabled"));
  }
  getClassMap() {
    const t = {
      rounded: !0,
      "items-center": !0,
      "justify-center": !0,
      "appearance-none": !0,
      "box-border": !0,
      "cursor-pointer": !0,
      flex: !0,
      "h-12": !this.size.includes(c.SMALL),
      "w-12": !this.size.includes(c.SMALL),
      "h-9": this.size.includes(c.SMALL),
      "w-9": this.size.includes(c.SMALL),
      "p-0": !0,
      "mt-5": this.size.includes(c.FIELD),
      //Was 20px in styles.ts
      "-mt-px": this.size.includes(c.SMALL),
      "focus:outline": !0,
      "focus:outline-2": !0,
      "focus:outline-offset-2": !0,
      "focus:outline-blue-070": !0,
      "disabled:pointer-events-none": !0
    }, e = !!h(".container-default", this), o = !!h(".container-secondary", this), r = !!h(".container-tertiary", this);
    let i = {};
    switch (this.kind) {
      case "primary":
        i = {
          "text-neutral-140": !0,
          "dark:text-neutral-000": !0,
          "bg-blue-060": !0,
          "dark:bg-blue-080": !0,
          "hover:bg-blue-070": !0,
          "dark:hover:bg-blue-070": !0,
          "active:bg-blue-080": !0,
          "dark:active:bg-blue-060": !0,
          "dark:focus:bg-blue-080": !0,
          "disabled:bg-neutral-090": !0,
          "dark:disabled:bg-neutral-050": !0
        };
        break;
      case "secondary":
        i = {
          "text-blue-060": !0,
          "dark:text-blue-080": !0,
          "bg-transparent": !0,
          "hover:bg-neutral-130": e,
          "hover:bg-neutral-120": o,
          "hover:bg-neutral-110": r,
          "dark:hover:bg-neutral-010": e,
          "dark:hover:bg-neutral-020": o,
          "dark:hover:bg-neutral-030": r,
          "active:bg-neutral-120": e,
          "active:bg-neutral-110": o,
          "active:bg-neutral-100": r,
          "dark:active:bg-neutral-020": e,
          "dark:active:bg-neutral-030": o,
          "dark:active:bg-neutral-040": r,
          border: !0,
          "border-solid": !0,
          "border-blue-060": !0,
          "dark:border-blue-080": !0,
          "hover:border-blue-070": !0,
          //dark:hover:border:bg the same
          "active:border-blue-080": !0,
          "dark:active:border-blue-060": !0,
          //Focus falls back to normal light/dark
          "disabled:text-neutral-090": !0,
          "dark:disabled:text-neutral-050": !0,
          "disabled:border-neutral-090": !0,
          "dark:disabled:border-neutral-050": !0
        };
        break;
      case "ghost":
        i = {
          "text-blue-060": !0,
          "dark:text-blue-080": !0,
          "bg-transparent": !0,
          "hover:bg-neutral-130": e,
          "hover:bg-neutral-120": o,
          "hover:bg-neutral-110": r,
          "dark:hover:bg-neutral-010": e,
          "dark:hover:bg-neutral-020": o,
          "dark:hover:bg-neutral-030": r,
          "active:bg-neutral-120": e,
          "active:bg-neutral-110": o,
          "active:bg-neutral-100": r,
          "dark:active:bg-neutral-020": e,
          "dark:active:bg-neutral-030": o,
          "dark:active:bg-neutral-040": r,
          //Is 1px border spacing required for ghost?
          // "border": true,
          // "border-solid": true,
          // "border-transparent": true,,
          "disabled:text-neutral-090": !0,
          "dark:disabled:text-neutral-050": !0
        };
        break;
    }
    return classMap(Object.assign(t, i));
  }
  createTagName(t) {
    return o(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    return n$1`
      <button
        id="button-icon"
        name=${this.name}
        part="interactive button-icon"
        class="${this.getClassMap()}"
        ?autofocus=${this.autofocus}
        ?disabled=${this.disabled}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label=${this.labelText}
        type=${this.type}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @click=${this.handleClick}
      >
        <${this.createTagName("-button-icon-icon")}
          exportparts="icon"
          ?outlined=${this.outlined}
          ?filled=${this.filled}
          icon=${this.icon}
          size=${this.iconSize}
        ></${this.createTagName("-button-icon-icon")}>
        <span class="sr-only">
          <slot>${this.labelText}</slot>
        </span>
      </button>
    `;
  }
};
m.styles = [g.styles || [], unsafeCSS(O)];
let n = m;
s([
  property({ type: Boolean, reflect: !0 })
], n.prototype, "autofocus");
s([
  property({ type: Boolean, reflect: !0 })
], n.prototype, "disabled");
s([
  property({ attribute: "label-text" })
], n.prototype, "labelText");
s([
  property({ reflect: !0 })
], n.prototype, "kind");
s([
  property()
], n.prototype, "size");
s([
  property({ reflect: !0 })
], n.prototype, "type");
s([
  property()
], n.prototype, "icon");
s([
  property({ reflect: !0, type: Boolean })
], n.prototype, "outlined");
s([
  property({ reflect: !0, type: Boolean })
], n.prototype, "filled");
s([
  property({ reflect: !0, type: String })
], n.prototype, "name");
s([
  property({ reflect: !0, type: String, attribute: "icon-size" })
], n.prototype, "iconSize");
s([
  query("button")
], n.prototype, "buttonNode");
try {
  customElements.define("adc-button-icon", n), console.warn("@aileron/button-icon is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/button-icon");
} catch {
}

var version = "1.15.2";

class HeaderFeatureToggles {}
HeaderFeatureToggles.SHOWSEARCH = ["en_CB", "en_US", "en_GB", "es_US"];
HeaderFeatureToggles.HIDELOYALTYBUTTONS = ["es_ES", "en_EU", "en_AP", "fr"];
HeaderFeatureToggles.LOYALTYBUTTONOVERRIDE = ["en_US", "en_GB", "fr_CA"];

const styles = css`.mobile-view--visible{display:none !important}.skip-link{left:-999px;position:absolute;top:-999px;display:block}.skip-link:focus{top:20px;left:5px;position:relative}.popover{z-index:77;position:absolute;width:270px}.popover-spa{z-index:1}header{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:"American Sans",sans-serif;font-family:var(--adc-typography-body1-font-family,var(--adc-typography-font-family,"American Sans",sans-serif));font-size:1rem;font-size:var(--adc-typography-body1-font-size,1rem);line-height:1.375rem;line-height:var(--adc-typography-body1-line-height,1.375rem);font-weight:400;font-weight:var(--adc-typography-body1-font-weight,400);letter-spacing:.01em;letter-spacing:var(--adc-typography-body1-letter-spacing,0.01em);text-decoration:inherit;-webkit-text-decoration:var(--adc-typography-body1-text-decoration,inherit);text-decoration:var(--adc-typography-body1-text-decoration,inherit);text-transform:inherit;text-transform:var(--adc-typography-body1-text-transform,inherit);font-family:AmericanSans,sans-serif;font-size:16px;bottom:0;left:0;width:100%}header :host(:focus-within){outline:0}header img{display:inline-block;vertical-align:middle;max-width:100%;height:auto}header hr{border-style:none;width:1px;background-color:#d0dae0;margin:0 24px;margin-block-start:0}header .grid-bottom,header .grid-top{max-width:1216px;margin:0 auto}header .common-note{margin:0 0 16px}header .close-menu-icon{display:flex;justify-content:center}header .close-menu-icon::part(interactive button-icon){color:var(--neutral-010);height:20px;margin-top:3px;margin-bottom:-5px}header .operation-menu::part(interactive button-icon){color:var(--blue-060)}header adc-row,header adc-column,header adc-tab{outline:0}header .button-column{padding:0 1rem}header .panel-container{display:block;position:relative;top:4px;padding:0;box-sizing:border-box;width:99vw;max-width:1216px;margin:0 auto 0 -314px}header .panel-note{color:#465762;font-family:AmericanSans,sans-serif;font-style:normal;font-weight:400;font-size:24px;line-height:30px;width:208px;height:90px}header .panel-note strong{font-weight:700}header .tabs-small::part(tabs-container){margin-top:4px}header .button::part(interactive){height:48px;font-weight:700}header .button-login{margin-top:4px;margin-right:4px}header .button-join::part(interactive){margin-top:4px;margin-right:4px;padding:0 18px}header .profile-container{display:flex;justify-content:space-between}header .one-world{vertical-align:middle;margin-top:8px;margin-left:16px;width:40px;height:40px}header .aa-logo{max-width:200px;width:100%;height:48px;margin-top:4px}header .logo-column{display:flex}header .aa-logo-link{text-decoration:none}header .tab-nav::part(tab){text-transform:none;font-size:16px;white-space:nowrap}header .tab-divider{padding:0;max-width:1216px}header .lng-selector-desktop{display:flex;justify-content:flex-end;align-items:center;position:relative;min-height:50px}header .lng-selector-mobile{display:flex;justify-content:flex-end;align-items:center}header .link-col{max-width:310px}header .panel-links::part(anchor),header .common-note::part(anchor){text-decoration:none}header .panel-links::part(anchor):hover,header .common-note::part(anchor):hover{text-decoration:underline}header .buttons-mobile{display:flex;justify-content:flex-end;align-items:center;padding-left:0;padding-right:0}header .row-mobile-language{margin-bottom:10px;margin-right:0}header .nav-links{padding:8px 0 8px 18px;display:inherit}header .sidenav{height:100%;width:60vw;position:fixed;z-index:99;top:0;right:-60vw;background-color:#39474f;overflow-x:hidden;padding-top:18px;transition:all .3s ease-in-out}header .sidenav .closebtn{position:absolute;top:0;right:25px;font-size:36px;margin-left:50px}header #main{padding:16px}header .sidenav-overlay{height:100%;width:40vw;position:fixed;z-index:99;top:0;left:0;background-color:transparent;overflow-x:hidden;padding-top:60px}header .sidePanelOpen{transition:all .3s ease-in-out}header .nav-item{--color-light-mode-background-container-default:newpalette.\$gray-700;--color-light-mode-text-text-status-error:newpalette.\$white;--color-light-mode-icon-icon-interactive:newpalette.\$white;--typography-1440-body-paragraph-font-family:"AmericanSans Light",sans-serif;--color-light-mode-border-border-tertiary:newpalette.\$gray-700}header .nav-item:focus{outline:1px solid #fff}header .nav-item::part(expando){color:#fff;background-color:#39474f}header .nav-item::part(expando-icon){color:#fff}header .nav-item::part(content){background-color:#39474f}header .link-item{--color-light-mode-interactive-hover-hover-on-container-default:newpalette.\$gray-700;--color-light-mode-background-container-status-information-on-container-secondary:newpalette.\$gray-700}header .link-item::part(link-item):focus{outline:1px solid #fff;-webkit-text-decoration:underline #fff;text-decoration:underline #fff}header .mobile-link{margin-right:26px}header .divider-container{padding-left:15px;padding-right:15px}header .divider-bottom::part(divider){margin-bottom:auto;margin-top:12px}header .travelAlert::part(anchor){color:var(--aileron-light-mode-text-text-status-warning,#ae3f13)}header .travel-column{padding:10px 0 10px 25px}header .lang-selector-search-row{justify-content:right}header .search-mobile{padding:0 16px 16px 16px}@media(max-width:1279px){header .panel-container{width:98vw;display:block;margin:0 auto 0 -26vw;padding:0 24px}header .col-side{flex:0 0 calc(25%);max-width:calc(25%);outline:0}header .col-center{display:block;flex:0 0 calc(50%);max-width:calc(50%);outline:0}header .tabs-small{min-width:340px}header .tab-divider{padding-right:10px}}@media(min-width:1023px) and (max-width:1248px){header .grid-top,header .grid-bottom{padding:0 32px}}@media screen and (min-width:1023px) and (max-width:1150px){header .tab-nav::part(tab){font-size:14px}}@media screen and (min-width:1023px) and (max-width:1190px){header .aa-logo{height:36px;max-width:156px;margin-top:8px}header .button::part(interactive){height:36px;font-weight:700}header .one-world{height:30px;width:30px;margin-top:12px}header .button-column{padding:0;margin-top:4px}header .logo-column{justify-content:flex-end}header .grid-bottom{padding:0}}@media screen and (max-height:450px){header .sidenav{padding-top:15px}header .sidenav a{font-size:18px}}@media(max-width:428px){header .aa-account{margin-right:4px}}@media only screen and (max-width:390px){header .button-login{margin-right:4px}}@media screen and (max-width:1023px){.mobile-view--hidden{display:none !important}.mobile-view--visible{display:inherit !important}.row-header-mobile{margin-top:10px;margin-right:0}.logo-column-mobile{display:flex;align-items:center}.col-side{display:inherit;flex:inherit;max-width:inherit;outline:inherit}header .aa-logo{margin-left:10px;max-width:156px;height:36px}header .button::part(interactive){height:36px;font-weight:700}.skip-link:focus{left:25px;position:relative;top:-5px}.hidden--tablet-down{display:none !important}.nav-links::part(anchor){--icon-fill:white;color:#fff;text-decoration:none}.nav-links::part(anchor):hover{color:#fff;text-decoration:underline;cursor:pointer}.nav-links::part(anchor):focus{text-decoration:underline;outline:1px solid #fff}#join{display:none}}@media screen and (min-width:800px) and (max-width:1023px){header{box-sizing:border-box;padding:16px 32px}}@media screen and (max-width:799px){header{box-sizing:border-box;padding:16px}}`;

class HeaderTranslations {}
HeaderTranslations.DATA = {
  "en_US": {
    "Login": "Log in",
    "Join": "Join",
    "SearchAACom": "Search AA.com\xAE",
    "SubmitSearch": "Submit search",
    "SkipToGlobalNavigation": "Skip to global navigation",
    "SkipToContent": "Skip to content",
    "SkipToFooter": "Skip to footer",
    "MobileNav": "Menu link",
    "CloseMenu": "Close menu",
    "LogInPopoverHeading": "Have an AAdvantage\xAE account?",
    "LogInPopoverBody": "Log in here.",
    "TravelAlerts": "Travel alerts",
    "HomePageLink": "American Airlines logo link to home page"
  },
  "es": {
    "Login": "Ingrese",
    "Join": "\xDAnase",
    "SearchAACom": "Buscar en aa.com",
    "SubmitSearch": "Enviar b\xFAsqueda",
    "SkipToGlobalNavigation": "Pasar a la navegaci\xF3n",
    "SkipToContent": "Pasar al contenido",
    "SkipToFooter": "Pasar al pie de p\xE1gina",
    "MobileNav": "Enlace del men\xFA",
    "CloseMenu": "Cerrar men\xFA",
    "LogInPopoverHeading": "\xBFTiene una cuenta AAdvantage\xAE?",
    "LogInPopoverBody": "Ingrese con su contrase\xF1a aqu\xED.",
    "TravelAlerts": "Alertas para su viaje",
    "HomePageLink": " Logo de American Airlines lleva a la p\xE1gina de inicio"
  },
  "fr": {
    "Login": "Connectez-vous",
    "Join": "Rejoindre",
    "SkipToGlobalNavigation": "Passer \xE0 la navigation g\xE9n\xE9rale",
    "SkipToContent": "Passer au contenu",
    "SkipToFooter": "Passer au bas de page",
    "MobileNav": "Lien de menu",
    "CloseMenu": "Fermer le menu",
    "LogInPopoverHeading": "Avez-vous un compte AAdvantage\xAE?",
    "LogInPopoverBody": "Connectez-vous ici."
  },
  "pt": {
    "Login": "Efetuar Login",
    "Join": "Associe-se",
    "SkipToGlobalNavigation": "Ir para navega\xE7\xE3o global",
    "SkipToContent": "Ir para conte\xFAdo",
    "SkipToFooter": "Ir para rodap\xE9",
    "MobileNav": "Liga\xE7\xE3o do menu",
    "CloseMenu": "Fechar menu",
    "LogInPopoverHeading": "Possui uma conta AAdvantage\xAE?",
    "LogInPopoverBody": "Fa\xE7a login aqui."
  },
  "fr_CA": {
    "SkipToGlobalNavigation": "Passer \xE0 la navigation globale",
    "SkipToContent": "Passer au contenu",
    "SkipToFooter": "Passer au pied de page",
    "MobileNav": "Lien de menu",
    "CloseMenu": "Fermer le menu",
    "TravelAlerts": "Alerte voyage (en anglais)",
    "HomePageLink": "Lien vers la page d'accueil du logo American Airlines"
  },
  "pt_BR": {
    "SkipToGlobalNavigation": "Pular para navega\xE7\xE3o global",
    "SkipToContent": "Pular para conte\xFAdo",
    "SkipToFooter": "Pular para rodap\xE9",
    "MobileNav": "Link do menu",
    "CloseMenu": "Fechar menu",
    "TravelAlerts": "Alertas de viagem",
    "HomePageLink": "Logo da American Airlines \u2013 link para p\xE1gina inicial"
  },
  "it_IT": {
    "SkipToGlobalNavigation": "Passa a navigazione globale",
    "SkipToContent": "Passa al contenuto",
    "SkipToFooter": "Passa a pi\xE8 di pagina",
    "MobileNav": "Link al menu",
    "CloseMenu": "Chiudi menu"
  },
  "fi_FI": {
    "SkipToGlobalNavigation": "Passa a navigazione globale",
    "SkipToContent": "Passa al contenuto",
    "SkipToFooter": "Passa a pi\xE8 di pagina",
    "MobileNav": "Link al menu",
    "CloseMenu": "Chiudi menu"
  },
  "de_DE": {
    "SkipToGlobalNavigation": "Zum \xFCbergeordneten Men\xFC",
    "SkipToContent": "Zum Inhalt",
    "SkipToFooter": "Zur Fu\xDFzeile",
    "MobileNav": "Men\xFC Link",
    "CloseMenu": "Men\xFC schlie\xDFen"
  },
  "nl_NL": {
    "SkipToGlobalNavigation": "Verdergaan naar globale navigatie",
    "SkipToContent": "Verdergaan naar content",
    "SkipToFooter": "Verdergaan naar voettekst",
    "MobileNav": "Link naar menu",
    "CloseMenu": "Menu sluiten"
  },
  "ko_KR": {
    "SkipToGlobalNavigation": "\uAE00\uB85C\uBC8C \uB124\uBE44\uAC8C\uC774\uC158\uC73C\uB85C \uC774\uB3D9",
    "SkipToContent": "\uCF58\uD150\uCE20\uB85C \uC774\uB3D9",
    "SkipToFooter": "\uBC14\uB2E5\uAE00\uB85C \uC774\uB3D9",
    "MobileNav": "\uBA54\uB274 \uB9C1\uD06C",
    "CloseMenu": "\uBA54\uB274 \uB2EB\uAE30"
  },
  "ja_JP": {
    "SkipToGlobalNavigation": "\u30B0\u30ED\u30FC\u30D0\u30EB\u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3\u3078\u30B9\u30AD\u30C3\u30D7",
    "SkipToContent": "\u30B3\u30F3\u30C6\u30F3\u30C4\u3078\u30B9\u30AD\u30C3\u30D7",
    "SkipToFooter": "\u30D5\u30C3\u30BF\u30FC\u3078\u30B9\u30AD\u30C3\u30D7",
    "MobileNav": "\u30E1\u30CB\u30E5\u30FC\u30EA\u30F3\u30AF",
    "CloseMenu": "\u30E1\u30CB\u30E5\u30FC\u3092\u9589\u3058\u308B"
  },
  "zh_CN": {
    "SkipToGlobalNavigation": "\u8DF3\u5230\u5168\u7403\u5BFC\u822A",
    "SkipToContent": "\u8DF3\u5230\u76EE\u5F55",
    "SkipToFooter": "\u8DF3\u5230\u9875\u811A",
    "MobileNav": "\u83DC\u5355\u94FE\u63A5",
    "CloseMenu": "\u5173\u95ED\u83DC\u5355"
  },
  "zh_HK": {
    "SkipToGlobalNavigation": "\u8DF3\u81F3\u5168\u7403\u700F\u89BD",
    "SkipToContent": "\u8DF3\u81F3\u5167\u5BB9",
    "SkipToFooter": "\u8DF3\u81F3\u9801\u5C3E",
    "MobileNav": "\u9078\u55AE\u9023\u7D50",
    "CloseMenu": "\u95DC\u9589\u9078\u55AE"
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
registerComponent$1("hp-header");
registerComponent$2("hp-header");
registerComponent$3("hp-header");
registerComponent$4("hp-header");
registerComponent$5("hp-header");
registerComponent$6("hp-header");
let Header = class extends HostListenerMixin(LitElement) {
  constructor() {
    super();
    this.localeCode = "en_US";
    this.searchInput = "";
    this.data = new HeaderDataController(this);
    this.name = "Header";
    this.open = false;
    this.contentId = "aa-content-frame";
    this.goDark = false;
    this._handleTabClick = event => {
      if (event.target !== this) {
        this._dropdownToggled(new CustomEvent("dropdown-toggled", {
          bubbles: true,
          composed: true,
          detail: ""
        }));
      }
    };
  }
  render() {
    var _a, _b, _c, _d, _e;
    this.startTime = new Date().getTime();
    this.localeCode = TranslationDataController.retrieveLocale();
    this.showSearchField = this.showSearch();
    TranslationDataController.getLocaleTranslations(this.localeCode, HeaderTranslations);
    TranslationDataController.getLocaleTranslations(this.localeCode, GlobalTranslations);
    this.isInSpa = !!document.querySelector("app-root");
    this.goDark = (_c = (_b = (_a = this.data) == null ? void 0 : _a.goDarkData) == null ? void 0 : _b.goDark) != null ? _c : false;
    return html`
      <header @click="${this._captureHeaderEvent}" @keydown="${this._captureHeaderEvent}" @dropdown-toggled=${this._dropdownToggled}>
        ${this.displayDesktop((_d = this.data) == null ? void 0 : _d.menuData)}
        ${this.displayMobile((_e = this.data) == null ? void 0 : _e.menuData)}
      </header>
    `;
  }
  async getUpdateComplete() {
    const result = await super.getUpdateComplete();
    this.loadTime = new Date().getTime() - this.startTime;
    return result;
  }
  displayDesktop(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    return html`
      <hp-header-grid class="grid-top mobile-view--hidden">
        <adc-row class="lang-selector-search-row">
          <adc-column col-desktop="3">
            <hp-header-link class="skip-link" href="#main-navigation" @click="${this._handleSkipLink}"
                      @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToGlobalNavigation"]}
            </hp-header-link>
            <hp-header-link class="skip-link" href="#${this.contentId}" @click="${this._handleSkipLink}"
                      @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToContent"]}</hp-header-link>
            <hp-header-link class="skip-link" href="#aa-footer" @click="${this._handleSkipLink}"
                      @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToFooter"]}
            </hp-header-link>
          </adc-column>
          <adc-column col-desktop="3">
          </adc-column>
          <adc-column class="col-side lng-selector-desktop">
          ${location.href.includes(Header.fullSiteUrl) ? this.showMobileLink() : ""}
            <adc-language-selector class="unique-dropdown" alignDialogRight="${this.showSearchField}"></adc-language-selector>
          </adc-column>
          ${this.showSearchField ? html`<adc-column class="col-side">${this.searchBox()}</adc-column>` : ""}
        </adc-row>
      </hp-header-grid>
      <hp-header-grid class="mobile-view--hidden grid-bottom">
        <adc-row id="main-navigation" class="row-header-mobile">
          <adc-column col-desktop="3" col-phone="2.5" class="col-side logo-column-mobile logo-column">
            <a href="${(_a = data == null ? void 0 : data.logo) == null ? void 0 : _a.href}" aria-label="${TranslationDataController.translations["HomePageLink"]}" class="aa-logo-link">
              <img class="aa-logo" src="${(_b = data == null ? void 0 : data.logo) == null ? void 0 : _b.src}" alt="${(_c = data == null ? void 0 : data.logo) == null ? void 0 : _c.ImgAltText}">
            </a>
            <a id="header-one-world-logo"
              href="${(_d = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _d.href}"
              hidden-label-text="${((_e = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _e.newWin) ? ((_f = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _f.external) ? data.newWinTextExternal : data.newWinText : ""}"
              target="${((_g = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _g.newWin) ? "_blank" : "_self"}">
              <img class="one-world"
                alt="${(_h = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _h.ImgAltText}"
                src="${(_i = data == null ? void 0 : data.oneWorldLogo) == null ? void 0 : _i.src}">
            </a>
          </adc-column>
          <adc-column col-desktop="6" class="col-center">
            <hp-header-tabs class="tabs-small mobile-view--hidden" id="tabs">
              ${data == null ? void 0 : data.meganavLinks.menu.map(menu => html`
                  <adc-tab class="tab-nav"
                           label="${menu.heading}"
                           value="${menu.heading}"
                           @click="${this._handleTabToggle}"
                           @keydown="${this._handleTabKeydown}">${menu.heading}
                  </adc-tab>
                  ${this.displayTabPanel(menu, data == null ? void 0 : data.meganavLinks.commonLinks, data)}
                `)}
            </hp-header-tabs>
          </adc-column>
          <adc-column class="${this._isSecureUser(this.data.authStatus) ? "profile-container" : ""} button-column"
                      col-desktop="3">
                      ${this.data.isDataFetched ? this._isSecureUser(this.data.authStatus) ? this.displayAccountDropdown() : this.displayButtons("") : ""}
          </adc-column>
        </adc-row>
          <adc-divider class="divider-bottom" color="tertiary" size="x-small" spacing="12"></adc-divider>
      </hp-header-grid>`;
  }
  displayTabPanel(menu, commonLinks, data) {
    return html`
      <adc-tab-panel value="${menu.heading}" id="${menu.heading}" class="panel-container">
        <hp-header-grid>
          <adc-column class="tab-divider" col-desktop="12">
            <adc-divider color="tertiary" size="x-small" spacing="12"></adc-divider>
          </adc-column>
        </hp-header-grid>
        <hp-header-grid>
          <adc-row has-form="">
            <adc-column col-desktop="3">
            <div>
              <span class="panel-note" .innerHTML="${menu.sideNote}"></span>
            </div>
            </adc-column>
            ${menu.columns.map(column => html`
                <adc-column col-desktop="3" class="link-col">
                  ${column.Links.map(link => html`
                    <hp-header-link class="panel-links"
                      target="${link.newWin ? "_blank" : "_self"}"
                      href="${link.href}"
                      hidden-label-text="${link && link.newWin ? link.external ? data.newWinTextExternal : data.newWinText : ""}"
                      icon="${link.newWin ? "new-window" : ""}">
                      ${link.linkText}</hp-header-link>
                    <adc-divider color="secondary" size="x-small" spacing="12"></adc-divider>
                  `)}
                </adc-column>
            `)}
            <hr>
            <adc-column col-desktop="2">
              ${commonLinks.map(link => html`
                    <hp-header-link class="common-note"
                      target="${link.newWin ? "_blank" : "_self"}"
                      icon="${link.newWin ? "new-window" : ""}"
                      hidden-label-text="${link && link.newWin ? link.external ? data.newWinTextExternal : data.newWinText : ""}"
                      href="${link.href}">
                      ${link.linkText}</hp-header-link>
              `)}
            </adc-column>
          </adc-row>
        </hp-header-grid>
        <hp-header-grid>
          <adc-row>
            <adc-column col-desktop="12">
              <adc-button-icon class="close-menu-icon" value="${menu.heading}" icon="navigation:caret-up" kind="ghost"
              label-text=${TranslationDataController.translations["CloseMenu"]} @click="${this._handleTabToggle}"></adc-button-icon>
            </adc-column>
          </adc-row>
        </hp-header-grid>
      </adc-tab-panel>
    `;
  }
  displayMobile(data) {
    var _a, _b, _c;
    return html`
      <hp-header-grid class="mobile-view--visible">
        <adc-row class="row-mobile-header">
          <hp-header-link class="skip-link" href="#main-navigation--mobile" @click="${this._handleSkipLink}"
                    @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToGlobalNavigation"]}
          </hp-header-link>
          <hp-header-link class="skip-link" href="#${this.contentId}" @click="${this._handleSkipLink}"
                      @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToContent"]}</hp-header-link>
          <hp-header-link class="skip-link" href="#aa-footer" @click="${this._handleSkipLink}"
                    @keydown="${this._handleSkipLinkKeydown}">${TranslationDataController.translations["SkipToFooter"]}
          </hp-header-link>
        </adc-row>
        <adc-row class="row-mobile-header" id="main-navigation--mobile">
          <adc-column col-phone="2" class="logo-column-mobile">
            <a href="${(_a = data == null ? void 0 : data.logo) == null ? void 0 : _a.href}" aria-label="${TranslationDataController.translations["HomePageLink"]}">
              <img class="aa-logo" src="${(_b = data == null ? void 0 : data.logo) == null ? void 0 : _b.src}" alt="${(_c = data == null ? void 0 : data.logo) == null ? void 0 : _c.ImgAltText}">
            </a>
          </adc-column>
          <adc-column col-phone="2" class="buttons-mobile ">
            ${this.data.isDataFetched ? this._isSecureUser(this.data.authStatus) ? this.displayAccountDropdown() : this.displayButtons("sm") : ""}
            <adc-button-icon class="operation-menu" icon="operation:menu" kind="ghost" label-text=${TranslationDataController.translations["MobileNav"]}
                             @click="${this._handleClick}"></adc-button-icon>
            <div class="sidenav-overlay" ?hidden='${!this.open}' @click="${this._handleClick}"
                 @keyDown="${this._handleClick}"></div>
            <div class="sidenav" id="sidenav">
              ${this.showSearchField ? html`<div class="search-mobile">${this.searchBox()}</div>` : ""}
              ${data == null ? void 0 : data.meganavLinks.commonLinks.map(link => html`
                  <hp-header-link class="nav-links"
                    icon="chevron"
                    href="${link.href}">
                    ${link.linkText} ${link.newWin ? this.showNewWindow(link, data) : ""}
                  </hp-header-link>
                `)}
              <div class="divider-container">
                <adc-divider class="divider" color="tertiary" size="x-small" spacing="12"></adc-divider>
              </div>
              <hp-header-nav-bar class="nav-bar">
                ${data == null ? void 0 : data.meganavLinks.menu.map(menu => html`
                    <adc-nav-item id="mobile-nav-bar" class="nav-item"
                                  label-text="${menu.heading}"
                    >
                      ${menu.columns.map(column => html`
                        ${column.Links.map(link => html`
                            <div>
                              <hp-header-link class="nav-links" icon="chevron" href="${link.href}" >
                                ${link.linkText} ${link.newWin ? this.showNewWindow(link, data) : ""}
                              </hp-header-link>
                            </div>
                          `)}
                      `)}
                    </adc-nav-item>
                  `)}
              </hp-header-nav-bar>
            </div>
          </adc-column>
        </adc-row>
        <adc-divider color="tertiary" spacing="16" size="small"></adc-divider>
        <adc-row class="row-mobile-language">
          <adc-column col-phone="2" class="travel-column">
          ${!this.isInSpa && GlobalDataController._isHomePage() ? this.travelAlert() : ""}
          </adc-column>
          <adc-column class="lng-selector-mobile" col-phone="2">
            <adc-language-selector class="unique-dropdown" alignDialogRight="${this.showSearchField}"></adc-language-selector>
          </adc-column>
        </adc-row>
      </hp-header-grid>
    `;
  }
  travelAlert() {
    return html`
      <hp-header-link class="travelAlert" href="/i18n/travel-info/travel-alerts.jsp" icon="chevron" >
        <adc-icon icon="signal:warning"></adc-icon>${TranslationDataController.translations["TravelAlerts"]}
      </hp-header-link>
    `;
  }
  showNewWindow(link, data) {
    return html`
      <hp-header-link class="nav-links"
        href="${link.href}"
        icon="${link.newWin ? "new-window" : ""}"
        hidden-label-text="${link && link.newWin ? link.external ? data.newWinTextExternal : data.newWinText : ""}"
        target="${link.newWin ? "_blank" : "_self"}">
      </hp-header-link>
    `;
  }
  showMobileLink() {
    return html`
      <hp-header-link class="mobile-link" href="/homePage.do?site_preference=mobile">Mobile</hp-header-link>
    `;
  }
  _handleTabKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      this._handleTabToggle(event);
    }
    if (event.key === "Tab") {
      this._resetTabIndex();
    }
  }
  _dropdownToggled(event) {
    var _a;
    (_a = this.uniqueDropdown) == null ? void 0 : _a.forEach(dropdown => {
      dropdown.headerToggleDropdown(event);
    });
  }
  _captureHeaderEvent(event) {
    event.stopPropagation();
    const hasUniqueDropdownClass = event.target.classList.contains("unique-dropdown");
    if (!hasUniqueDropdownClass) {
      this._dropdownToggled(new CustomEvent("dropdown-toggled", {
        bubbles: true,
        composed: true,
        detail: ""
      }));
    }
  }
  _handleTabToggle(event) {
    const tabsValue = event.target.getAttribute("value");
    if (this.tabs.selected === tabsValue) {
      setTimeout(() => {
        this.tabs.selected = "";
      }, 10);
      this._resetTabIndex();
    }
  }
  _resetTabIndex() {
    setTimeout(() => {
      const firstTab = [...this.tabs.querySelectorAll("adc-tab")][0].renderRoot.querySelector("button");
      firstTab.setAttribute("tabindex", "0");
    }, 100);
  }
  _handleSkipLink(event) {
    event.preventDefault();
    if (event.target.href === "#main-navigation" || event.target.href === "#main-navigation--mobile") {
      this._addScrollIntoView(event, "adc-header");
    } else if (event.target.href === "#aa-footer") {
      this._addScrollIntoView(event, "adc-footer");
    } else if (event.target.href === `#${this.contentId}`) {
      event.target.blur();
      const mainContent = document.querySelector(`#${this.contentId}`);
      mainContent == null ? void 0 : mainContent.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }
  _addScrollIntoView(event, selector) {
    var _a;
    event.target.blur();
    const shadowRoot = (_a = document.querySelector(selector)) == null ? void 0 : _a.shadowRoot;
    const component = shadowRoot == null ? void 0 : shadowRoot.querySelector(event.target.href);
    component.scrollIntoView({
      behavior: "smooth"
    });
  }
  _handleSkipLinkKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      this._handleSkipLink(event);
    }
  }
  _handleClick() {
    this._handleUserInitiatedToggle();
    if (this.open) {
      document.body.style.right = "60vw";
      document.body.style.position = "relative";
      this.sidenav.style.right = "0";
    } else {
      document.body.style.right = "0";
      document.body.style.position = "";
      this.sidenav.style.right = "-60vw";
    }
  }
  _handleUserInitiatedToggle(open = !this.open) {
    const init = {
      bubbles: true,
      cancelable: true,
      composed: true,
      detail: {
        open
      }
    };
    if (this.dispatchEvent(new CustomEvent(this.constructor.eventBeforeToggle, init))) {
      this.open = open;
      this.dispatchEvent(new CustomEvent(this.constructor.eventToggle, init));
    }
  }
  displayAccountDropdown() {
    return html`<adc-account-dropdown class="aa-account unique-dropdown"></adc-account-dropdown>`;
  }
  displayPopOver() {
    return html`
      <adc-popover heading="${TranslationDataController.translations["LogInPopoverHeading"]}" kind="secondary" placement="bottom" class="hidden--tablet-down popover ${this.isInSpa ? "popover-spa" : ""}">
        ${TranslationDataController.translations["LogInPopoverBody"]}
      </adc-popover>`;
  }
  displayButtons(size) {
    let shouldShowButtons = true;
    const rollup = TranslationDataController.getLocaleRollup(this.localeCode);
    const locales = [this.localeCode, ...(rollup || [])];
    locales.forEach(locale => {
      if (HeaderFeatureToggles.HIDELOYALTYBUTTONS.includes(locale)) {
        shouldShowButtons = false;
        return;
      }
    });
    if (HeaderFeatureToggles.LOYALTYBUTTONOVERRIDE.includes(this.localeCode)) {
      shouldShowButtons = true;
    }
    if (shouldShowButtons) {
      return html`
        ${this._checkLoginPage() ? "" : this.displayLoginButton(size)}
        ${GlobalDataController._isHomePage() ? [!this.goDark ? this.displayPopOver() : "", this.displayJoinButton(size)] : ""}`;
    }
    return html``;
  }
  displayLoginButton(size) {
    return html`
     <hp-header-button class="button-login button" size=${size} type="button" kind="primary" href="${this._getLoginUrl()}">${TranslationDataController.translations["Login"]}</hp-header-button>`;
  }
  displayJoinButton(size) {
    return html`
      <hp-header-button class="button-join button" size="${size}" type="button" id="join" kind="secondary" href="/loyalty/enrollment/enroll?from=comp_nav">${TranslationDataController.translations["Join"]}</hp-header-button>`;
  }
  _checkLoginPage() {
    return window.location.pathname.includes("/loyalty/login") || window.location.pathname.includes("/web/loyalty/profile/welcome");
  }
  showSearch() {
    let shouldShowSearch = false;
    const rollup = TranslationDataController.getLocaleRollup(this.localeCode);
    const locales = [this.localeCode, ...(rollup || [])];
    locales.forEach(locale => {
      if (HeaderFeatureToggles.SHOWSEARCH.includes(locale)) {
        shouldShowSearch = true;
        return;
      }
    });
    return shouldShowSearch;
  }
  searchBox() {
    return html`
      <hp-header-text-input autocomplete="off" name="input" id="searchInput" a11y-label=${TranslationDataController.translations["SearchAACom"]} placeholder=${TranslationDataController.translations["SearchAACom"]} type="text" validity-message="Validity message" value="" @keyup=${this.searchValue}>
          <adc-button-icon slot="button-icon" icon="operation:search-alt" @click=${this.onSubmit} @keyup=${this.searchValue} label-text=${TranslationDataController.translations["SubmitSearch"]} ></adc-button-icon>
      </hp-header-text-input>`;
  }
  static get eventBeforeToggle() {
    return "aileron-header-sidenav-beingtoggled";
  }
  static get eventToggle() {
    return "aileron-header-sidenav-toggled";
  }
  get version() {
    return version;
  }
  searchValue(event) {
    const keycode = event.keyCode;
    if (keycode > 47 && keycode < 58 || keycode === 32 || keycode === 13 || keycode > 64 && keycode < 91 || keycode > 95 && keycode < 112 || keycode > 185 && keycode < 193 || keycode > 218 && keycode < 223) {
      this.searchInput = event.target.value;
    }
    if (event.key === "Enter") {
      this.onSubmit();
    }
  }
  onSubmit() {
    if (this.searchInput) {
      window.location.href = `/search#?query=${this.searchInput}`;
    }
  }
  _getLoginUrl() {
    return `/loyalty/login?uri=%2floyalty%2flogin&previousPage=${this._buildContinueUrl()}&from=comp_nav`;
  }
  _buildContinueUrl() {
    var _a;
    let continueUrl = "";
    const encodedURI = encodeURIComponent(location.pathname);
    let queryString = (_a = location.search) == null ? void 0 : _a.substring(1);
    if (queryString.includes("&from=Nav")) {
      queryString = queryString.replace("&from=Nav", "");
    }
    continueUrl = continueUrl.concat(encodedURI);
    if (queryString && queryString !== "") {
      continueUrl = continueUrl.concat(`%3F${queryString}`);
    }
    return continueUrl;
  }
  _isSecureUser(authStatus) {
    return authStatus === AuthStatus.SECURED;
  }
};
Header.styles = styles;
Header.fullSiteUrl = "/homePage.do?fullHTMLVersion=true&site_preference=normal";
__decorateClass([property({
  type: String,
  reflect: true
})], Header.prototype, "localeCode", 2);
__decorateClass([property({
  type: String,
  reflect: true
})], Header.prototype, "searchInput", 2);
__decorateClass([query("#sidenav")], Header.prototype, "sidenav", 2);
__decorateClass([query("#tabs")], Header.prototype, "tabs", 2);
__decorateClass([queryAll(".unique-dropdown")], Header.prototype, "uniqueDropdown", 2);
__decorateClass([property({
  type: Number
})], Header.prototype, "loadTime", 2);
__decorateClass([property()], Header.prototype, "name", 2);
__decorateClass([property({
  type: Boolean,
  reflect: true
})], Header.prototype, "open", 2);
__decorateClass([property({
  type: String
})], Header.prototype, "contentId", 2);
__decorateClass([property({
  type: Boolean
})], Header.prototype, "goDark", 2);
__decorateClass([Log], Header.prototype, "render", 1);
__decorateClass([HostListener("document:click")], Header.prototype, "_handleTabClick", 2);
Header = __decorateClass([customElement("adc-header")], Header);
